import { Outlet } from "@remix-run/react";
import { CenterContentLayout } from "../../components/layout";

export default function AuthLayout() {
  return (
    <CenterContentLayout>
      <Outlet />
    </CenterContentLayout>
  );
}
